module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "team-person"
  }, [_c('el-dialog', {
    attrs: {
      "title": this.module === 'distribution' ? '客户分配' : '选择团队',
      "visible": _vm.dialogVisible,
      "modal": _vm.modal,
      "width": "700px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "custom-form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "筛选部门"
    }
  }, [_c('el-cascader', {
    attrs: {
      "clearable": "",
      "options": _vm.form.departmentTree,
      "change-on-select": "",
      "filterable": "",
      "placeholder": "请选择筛选部门"
    },
    on: {
      "change": _vm.chooseDepart
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择员工",
      "prop": "selectedUsers"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": _vm.module !== 'transfer',
      "filterable": "",
      "remote": "",
      "placeholder": _vm.placeholder,
      "remote-method": _vm.remoteMethod,
      "loading": _vm.loading
    },
    on: {
      "blur": _vm.blurSele
    },
    model: {
      value: (_vm.form.selectedUsers),
      callback: function($$v) {
        _vm.$set(_vm.form, "selectedUsers", $$v)
      },
      expression: "form.selectedUsers"
    }
  }, _vm._l((_vm.userList), function(item) {
    return _c('el-option', {
      key: item.userId,
      attrs: {
        "label": item.value,
        "value": item.userId
      }
    }, [_c('dl', {
      staticClass: "custom-option"
    }, [_c('dt', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.value))]), _vm._v(" "), _c('dd', {
      staticClass: "avatar"
    }, [_c('img', {
      attrs: {
        "src": item.avatar,
        "width": "32",
        "height": "32"
      }
    })]), _vm._v(" "), _c('dd', {
      staticClass: "department"
    }, _vm._l((item.department), function(d) {
      return _c('span', [_vm._v(_vm._s(d))])
    }))])])
  }))], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("保 存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17d3056f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/customer/team-person.vue
// module id = 1223
// module chunks = 82